import { api } from './apiClient';
import type { AuthUser } from './authApi';

export type UpdateUserProfilePayload = {
  name?: string;
  crp?: string;
  clinicName?: string;
  phone?: string;
  /** Bloco #45: WhatsApp pessoal (qualquer perfil). */
  whatsapp?: string;
  /** Bloco #45: WhatsApp da clínica (só administrador). */
  clinicWhatsapp?: string;
  email?: string;
  website?: string;
  address?: string;
  cnpj?: string;
  avatarUrl?: string;
  professionalPhoto?: string;
};

/**
 * Registra no servidor que o usuário leu e confirmou os Termos ou o Checklist
 * LGPD (primeiro acesso, blocos 30/31). Devolve o perfil atualizado.
 */
export function acknowledgeLegalDocument(document: 'terms' | 'lgpd'): Promise<AuthUser> {
  return api.post<AuthUser>('/users/legal-acknowledgements', { document });
}

export function updateUserProfile(payload: UpdateUserProfilePayload): Promise<AuthUser> {
  return api.patch<AuthUser>('/users/profile', payload);
}
